var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},_vm._l((_vm.item.blocks.slice(0, 2)),function(_item,index){return _c('sb-render',{key:_item._uid,class:{ 'w-4/5' : index == 1, 'w-1/5' : index == 0 },attrs:{"item":_item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }